import { Record } from 'immutable';

const ModelTrimRecord = Record({
    cabSizeTrimsBitField: 0,
    cabSizeTrimsBitFields: [],
    boxSizeTrimsBitField: 0,
    boxSizeTrimsBitFields: [],
    trimsBitField: 0,
    trimsBitFields: [],
    trimCode: '',
    selectionCode: '',
    enabled: true,
    visible: true,
    selected: false,
    userSelected: false,
    code: '',
    description: '',
    trimExtensionCode: '',
    trimExtensionDescription: '',
    rank: 0,
    configurationIds: {},
    features: {},
    featureIcons: {},
    comparisonModelTrimCode: '',
    comparisonModelTrim: '',
    comparisonModelTrimExtension: '',
    comparisonAddFeatures: {},
    comparisonRemoveFeatures: {},
    comparisonAddFeatureIcons: {},
});

class ModelTrim extends ModelTrimRecord {
    getSelectionCode() {
        return this.get('selectionCode');
    }

    getModelTrimFullDescription() {
        return this.trimExtensionDescription
            ? `${this.description} ${this.trimExtensionDescription}`
            : this.description;
    }

    /**
     * Return the Model Trim description or an empty string if it repeats or contain the Model Name.
     * @param {string} modelName the name of the model
     * @returns {string} description
     */
    getDescription(modelName) {
        if (!modelName) {
            return this.description;
        }

        return modelName === this.description || modelName.includes(this.description) ? '' : this.description;
    }
}

export default ModelTrim;
